import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import ImagePicker from '../../components/inputFields/ImagePicker';
import { patchSubCategory, postSubCategory } from '../../services/domains';

function SubCategoryForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rowData, setRowData] = useState(null);
    const [categoryData, setCategoryData] = useState(null);
    const [image, setImage] = useState(null);

    const handleImageSelect = (file) => {
        setImage(file);
    };

    useEffect(() => {
        if (location.state) {
            if (location.state.item) {
                setRowData(location.state.item);
                if (location.state.item.image) {
                    setImage(location.state.item.image);
                }
            }
            if (location.state.category) {
                setCategoryData(location.state.category);
            }
        }
    }, [location]);

    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const data = new FormData();
        if (image && typeof image === "object") {
            data.append("image", image);
        }
        data.append("category", categoryData.id);
        data.append("name", values.name);
        data.append("description", values.description);

        try {
            const response = categoryData ? await patchSubCategory({ data: data, id: rowData.id, }) : await postSubCategory(data);

            if (response?.status === 201 || response?.status === 200) {
                toast.success(categoryData ? "Subcategory Updated Successfully" : "Subcategory Added successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Bazzar', },
            { name: 'Domains', },
            { name: 'Categories', },
            { name: 'Sub Categories', },
            { name: categoryData ? 'Edit Sub Category' : 'Add Sub Category' },
        ]} />
        <div className="mt-8 gap-4">
            <Formik
                initialValues={rowData || {
                    name: "",
                    description: "",
                    order: "",
                }}
                enableReinitialize
                validationSchema={Yup.object({
                    name: Yup.string().required("Please enter a name"),
                })}
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, resetForm }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 gap-2">
                            <div className="h-40 w-40 aspect-square">
                                <ImagePicker
                                    preloadedImage={image}
                                    onImageSelect={handleImageSelect}
                                    placeholder='Select Logo'
                                />
                            </div>
                            <div className="flex flex-row gap-4">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-3 w-full">
                                    <InputField
                                        label="Name"
                                        name="name"
                                        placeholder="Name"
                                    />
                                    <InputField
                                        label="Description"
                                        name="description"
                                        type="text"
                                        placeholder="Write your description here..."
                                    />
                                    <InputField
                                        label="Order"
                                        name="order"
                                        type="number"
                                        placeholder="X"
                                    />
                                </div>
                            </div>
                            {/* Buttons */}
                            <div className="flex justify-end gap-6">
                                <div>
                                    <Button
                                        type="button"
                                        className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                        onClick={() => handleDiscardChanges(resetForm)}
                                        disabled={isSubmitting}
                                    >
                                        Discard Changes
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        type="submit"
                                        className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Saving..." : "Save"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default SubCategoryForm;